exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup90 .vs-popup {\n  width: 90% !important;\n}\n[dir] .vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td  {\n  padding: 1px 14px;\n}\n", ""]);

// exports
